import { Box, BoxProps } from '@mui/material'
import dayjs, { Dayjs } from 'dayjs'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import relativeTimePlugin from 'dayjs/plugin/relativeTime'
import { useMemo, useState } from 'react'

dayjs.extend(relativeTimePlugin)
dayjs.extend(localizedFormat)

type TProps = {
  date?: string | null | Date | number | undefined
  absolute?: boolean
  format?: Parameters<Dayjs['format']>[0]
  boxProps?: BoxProps
}

export default function DateDisplay(props: TProps) {
  const d = parseDate(props.date)
  if (!d) return null
  const [relative, setRelative] = useState<boolean>(!props.absolute)
  const toggleRelative = () => setRelative((r) => !r)

  const format = useMemo(() => {
    if (props.format) return props.format
    if (d.isSame(dayjs(), 'day')) return 'LT'
    if (d.isSame(dayjs(), 'year')) return 'MMM D'
    return 'L'
  }, [props.format, d])

  return (
    <Box
      component="time"
      dateTime={d.format('YYYY-MM-DD')}
      title={d.format('LLL')}
      onDoubleClick={() => toggleRelative()}
      sx={{ cursor: 'pointer', ...(props.boxProps?.sx || {}) }}
      {...(props.boxProps || {})}
    >
      {relative ? d.fromNow() : d.format(format)}
    </Box>
  )
}

export function parseDate(date: TProps['date'], raw: true): Date | null
export function parseDate(date: TProps['date'], raw?: false | undefined): Dayjs | null
export function parseDate(date: TProps['date'], raw?: boolean): Date | Dayjs | null {
  if (!date) return null
  const d = dayjs(date)
  if (!d.isValid()) return null
  if (raw) return d.toDate()
  return d
}
